import * as fetch from './fetch';
import * as toggleReminder from './toggleReminder';

export default {
  ...fetch,
  ...toggleReminder,
};
